import {
    archiveTask,
    attachmentsDelete,
    changeWorkflow,
    createPipelineStage,
    createSimpleTask,
    createTask,
    createWorkflow,
    deletePipelineStage,
    deleteTask,
    deleteWorkflow,
    doneTask,
    getAllWorkFlows,
    getArchiveTask,
    getDeleteTask,
    getDoneTask,
    getListArchiveTasks,
    getListDoneTask,
    getListTasks,
    getPipelineTasks,
    getPiplineName,
    getTaskActivitys,
    getTaskDetail,
    getTaskListByDate,
    getTaskReports,
    getTaskReportsTimeline,
    getVisitorTasks,
    getWorkflowDetails,
    getWorkflowPipelines,
    getWorkflowTasks,
    getWorkflowTasksWithPipelines,
    multipleTaskDelete,
    multipleTaskMove,
    multipleTaskDone,
    removeFromDoneTasks,
    updatePipelinePosition,
    updatePipelineStage,
    updateTask,
    updateTaskPosition,
    updateWorkflow,
    updateWorkflowOrder,
} from "../../api/tasks";

const tasks = {
    namespaced: true,
    state: {
        workflows: [],
        workflowCount: 0,
    },
    getters: {
        defaultWorkflow: (state) => {
            return state.workflows.find((workflow) => workflow.default);
        },
        getWorkflowById: (state) => (workflowId) => {
            return state.workflows.find((wf) => wf._id === workflowId);
        },
    },
    mutations: {
        SET_WORKFLOWS: (state, payload) => {
            state.workflows = payload;
        },
        SET_WORKFLOW_COUNT: (state, payload) => {
            state.workflowCount = payload;
        }
    },
    actions: {
        getVisitorTasks({}, { siteId, visitorId }) {
            return getVisitorTasks(siteId, visitorId).then((res) => res.data);
        },
        getWorkFlows({ commit }) {
            return getAllWorkFlows().then((res) => {
                // Backend artık { workflows, totalCount } objesi dönüyor
                const { workflows, totalCount } = res.data;
                
                // UI'da sadece aktif workflow'ları göster (çöp kutusunda ve kalıcı silinmiş olanlar hariç)
                commit("SET_WORKFLOWS", workflows.filter(wf => !wf.isTrash && !wf.isDeleted));
                
                // Limit kontrolü için backend'den gelen totalCount'u kullan
                // totalCount: Çöp kutusundakiler DAHİL (isTrash: true), Kalıcı silinmişler HARİÇ (isDeleted: true)
                commit("SET_WORKFLOW_COUNT", totalCount);
                
                return res.data;
            });
        },
        async getWorkflowTasks({ commit, state }, params) {
            const result = await getWorkflowTasksWithPipelines(
                params.workflowId,
                params
            ).then((res) => res.data);

            if (result.pipelines && params.workflowId) {
                const workflows = state.workflows.map((wf) => {
                    if (wf._id === params.workflowId) {
                        return Object.assign({}, wf, { pipeline: result.pipelines });
                    }
                    return wf;
                });
                commit("SET_WORKFLOWS", workflows);
            }

            return result.tasks || {};
        },
        async getPipelineTasks({}, params) {
            return getPipelineTasks(
                params.workflowId,
                params.pipelineId,
                params.assignees,
                params.showOverdue,
                params.page,
                params.perPage,
                params.owner,
                params.followers,
                params.dateRange,
                params.createdBy,
                params.tags,
                params.startDateRange,
                params.endDateRange,
                params.updateAtRange,
                params.pipelines,
                params.sortBy
            ).then((res) => res.data);
        },
        getArchiveTasks({}, params) {
            return getArchiveTask(
                params.workflowId,
                params.page,
                params.perPage,
                params.archivedDateRange
            ).then((res) => res.data);
        },
        getDeleteTask({}, params) {
            return getDeleteTask(params.workflowId, params.page, params.perPage, params.deletedDateRange).then((res) => res.data);
        },
        getDoneTasks({}, params) {
            return getDoneTask(params.workflowId, params.page, params.perPage, params.doneDateRange).then((res) => res.data);
        },
        getTaskActivities({}, params) {
            return getTaskActivitys(params.taskId, params.page, params.limit).then((res) => res.data);
        },
        updateTaskPosition({ commit, state }, params) {
            return updateTaskPosition(params.taskId, params.payload)
                .then((res) => {
                    const updatedTask = res.data;
                    const fromPipelineId = params.payload.fromPipelineId;
                    const toPipelineId = params.payload.pipelineStageId || updatedTask.pipelineStage;
                    const workflowId = params.payload.workflowId || updatedTask.workflow;

                    if (updatedTask && workflowId && fromPipelineId && toPipelineId && fromPipelineId !== toPipelineId) {
                        const workflows = state.workflows.map((wf) => {
                            if (wf._id === workflowId) {
                                const pipeline = wf.pipeline.map((pl) => {
                                    if (pl._id === fromPipelineId) {
                                        const newCount = Math.max(0, (pl.taskCount || 0) - 1);
                                        const newFilteredCount = pl.filteredTaskCount !== undefined
                                            ? Math.max(0, (pl.filteredTaskCount || 0) - 1)
                                            : newCount;
                                        return Object.assign({}, pl, {
                                            taskCount: newCount,
                                            filteredTaskCount: newFilteredCount
                                        });
                                    }
                                    if (pl._id === toPipelineId) {
                                        const newCount = (pl.taskCount || 0) + 1;
                                        const newFilteredCount = pl.filteredTaskCount !== undefined
                                            ? (pl.filteredTaskCount || 0) + 1
                                            : newCount;
                                        return Object.assign({}, pl, {
                                            taskCount: newCount,
                                            filteredTaskCount: newFilteredCount
                                        });
                                    }
                                    return pl;
                                });
                                return Object.assign({}, wf, { pipeline });
                            }
                            return wf;
                        });
                        commit("SET_WORKFLOWS", workflows);
                    }
                    return updatedTask;
                });
        },
        updatePipelinePosition({}, params) {
            return updatePipelinePosition(params.workflowId, params.pipelineId, params.position).then(
                (res) => res.data
            );
        },
        setWorkflows({ commit }, data) {
            commit("SET_WORKFLOWS", data);
        },
        deleteTask({ commit, state }, task) {
            return deleteTask(task._id)
                .then((res) => {
                    const deletedTask = res.data;
                    if (deletedTask && deletedTask.pipelineStage && deletedTask.workflow) {
                        const workflows = state.workflows.map((wf) => {
                            if (wf._id === deletedTask.workflow) {
                                const pipeline = wf.pipeline.map((pl) => {
                                    if (pl._id === deletedTask.pipelineStage) {
                                        const newCount = Math.max(0, (pl.taskCount || 0) - 1);
                                        // Eğer filtre varsa filtered count da azalt
                                        const newFilteredCount = pl.filteredTaskCount !== undefined
                                            ? Math.max(0, (pl.filteredTaskCount || 0) - 1)
                                            : newCount;
                                        return Object.assign({}, pl, {
                                            taskCount: newCount,
                                            filteredTaskCount: newFilteredCount
                                        });
                                    }
                                    return pl;
                                });
                                return Object.assign({}, wf, { pipeline });
                            }
                            return wf;
                        });
                        commit("SET_WORKFLOWS", workflows);
                    }
                    return deletedTask;
                });
        },
        doneTask({ commit, state }, { taskId, status, description }) {
            return doneTask(taskId, status, description).then((res) => {
                const doneTaskData = res.data;
                if (doneTaskData && doneTaskData.pipelineStage && doneTaskData.workflow) {
                    const workflows = state.workflows.map((wf) => {
                        if (wf._id === doneTaskData.workflow) {
                            const pipeline = wf.pipeline.map((pl) => {
                                if (pl._id === doneTaskData.pipelineStage) {
                                    const newCount = Math.max(0, (pl.taskCount || 0) - 1);
                                    const newFilteredCount = pl.filteredTaskCount !== undefined
                                        ? Math.max(0, (pl.filteredTaskCount || 0) - 1)
                                        : newCount;
                                    return Object.assign({}, pl, {
                                        taskCount: newCount,
                                        filteredTaskCount: newFilteredCount
                                    });
                                }
                                return pl;
                            });
                            return Object.assign({}, wf, { pipeline });
                        }
                        return wf;
                    });
                    commit("SET_WORKFLOWS", workflows);
                }
                return doneTaskData;
            });
        },
        removeFromDoneTasks({}, taskId) {
            return removeFromDoneTasks(taskId).then((res) => res.data);
        },
        toggleArchiveTask({ commit, state }, { workflowId, taskId, isArchived }) {
            return archiveTask(workflowId, taskId, isArchived).then((res) => {
                const archivedTaskData = res.data;
                if (archivedTaskData && archivedTaskData.pipelineStage && archivedTaskData.workflow) {
                    const workflows = state.workflows.map((wf) => {
                        if (wf._id === archivedTaskData.workflow) {
                            const pipeline = wf.pipeline.map((pl) => {
                                if (pl._id === archivedTaskData.pipelineStage) {
                                    const newCount = Math.max(0, (pl.taskCount || 0) - 1);
                                    const newFilteredCount = pl.filteredTaskCount !== undefined
                                        ? Math.max(0, (pl.filteredTaskCount || 0) - 1)
                                        : newCount;
                                    return Object.assign({}, pl, {
                                        taskCount: newCount,
                                        filteredTaskCount: newFilteredCount
                                    });
                                }
                                return pl;
                            });
                            return Object.assign({}, wf, { pipeline });
                        }
                        return wf;
                    });
                    commit("SET_WORKFLOWS", workflows);
                }
                return archivedTaskData;
            });
        },
        createSimpleTask({ commit, state }, payload) {
            return createSimpleTask(payload)
                .then((res) => res.data)
                .then((body) => {
                    if (body.workflow && body.pipelineStage) {
                    const workflows = state.workflows.map((wf) => {
                        if (wf._id === body.workflow) {
                                const pipeline = wf.pipeline.map((pl) => {
                                    if (pl._id === body.pipelineStage) {
                                        const newTaskCount = (pl.taskCount || 0) + 1;
                                        // Eğer filtre varsa filtered count da artır
                                        const newFilteredTaskCount = pl.filteredTaskCount !== undefined
                                            ? (pl.filteredTaskCount || 0) + 1
                                            : newTaskCount;
                                        return Object.assign({}, pl, {
                                            taskCount: newTaskCount,
                                            filteredTaskCount: newFilteredTaskCount
                                        });
                                    }
                                return pl;
                            });
                                return Object.assign({}, wf, { pipeline });
                        }
                        return wf;
                    });
                    commit("SET_WORKFLOWS", workflows);
                    }
                    return body;
                });
        },
        createTask({ commit, state }, payload) {
            return createTask(payload)
                .then((res) => res.data)
                .then((body) => {
                    if (body.workflow && body.pipelineStage) {
                    const workflows = state.workflows.map((wf) => {
                        if (wf._id === body.workflow) {
                                const pipeline = wf.pipeline.map((pl) => {
                                    if (pl._id === body.pipelineStage) {
                                        const newTaskCount = (pl.taskCount || 0) + 1;
                                        // Eğer filtre varsa filtered count da artır
                                        const newFilteredTaskCount = pl.filteredTaskCount !== undefined
                                            ? (pl.filteredTaskCount || 0) + 1
                                            : newTaskCount;
                                        return Object.assign({}, pl, {
                                            taskCount: newTaskCount,
                                            filteredTaskCount: newFilteredTaskCount
                                        });
                                    }
                                return pl;
                            });
                                return Object.assign({}, wf, { pipeline });
                        }
                        return wf;
                    });
                    commit("SET_WORKFLOWS", workflows);
                    }
                    return body;
                });
        },
        createWorkflow({ commit, state }, payload) {
            return createWorkflow(payload)
                .then((res) => res.data)
                .then((body) => {
                    commit("SET_WORKFLOWS", [...state.workflows, body]);
                    return body;
                });
        },
        updateWorkflow({ commit, state }, payload) {
            return updateWorkflow(payload.workflowId, payload.params)
                .then((res) => res.data)
                .then((updatedWorkflow) => {
                    const workflows = state.workflows.map((workflow) => {
                        if (workflow._id === updatedWorkflow._id) {
                            return Object.assign({}, updatedWorkflow);
                        }
                            return workflow;
                    });
                    commit("SET_WORKFLOWS", workflows);
                    return updatedWorkflow;
                });
        },
        getTaskDetail({}, taskId) {
            return getTaskDetail(taskId).then((res) => res.data);
        },
        updateTask({}, payload) {
            return updateTask(payload.taskId, payload.params).then((res) => res.data);
        },
        attachmentsDelete({}, payload) {
            return attachmentsDelete(payload.taskId, payload.attachmentId);
        },
        createPipelineStage({ state, commit }, payload) {
            const workflowId = payload.workflowId;
            return createPipelineStage(workflowId, payload)
                .then((res) => res.data)
                .then((pipeline) => {
                    const updatedWorkflows = state.workflows.map((wf) => {
                        if (wf._id === workflowId) {
                        const pipelines = [
                                ...wf.pipeline.slice(0, pipeline.order - 1),
                            pipeline,
                                ...wf.pipeline.slice(pipeline.order - 1),
                            ].map((pl, index) => Object.assign({}, pl, { order: index + 1 }));

                            return Object.assign({}, wf, {
                                pipeline: pipelines.sort((a, b) => a.order - b.order)
                            });
                        }
                        return wf;
                    });
                    commit("SET_WORKFLOWS", updatedWorkflows);
                    return pipeline;
                });
        },
        updatePipelineStage({}, payload) {
            return updatePipelineStage(payload.pipelineId, payload.params);
        },
        async getListTasks({ dispatch }, payload) {
            const tasksPromise = getListTasks(
                payload.assignees,
                payload.page,
                payload.perPage,
                payload.visitorId,
                payload.tableRecord,
                payload.showOverdue,
                payload.search,
                payload.priorities,
                payload.owner,
                payload.followers,
                payload.dateRange,
                payload.createdBy,
                payload.tags,
                payload.startDateRange,
                payload.endDateRange,
                payload.updateAtRange,
                payload.workflowId,
                payload.pipelines,
                payload.sortBy
            ).then((res) => res.data);

            if (payload.workflowId) {
                const filters = {
                    assignees: payload.assignees,
                    showOverdue: payload.showOverdue,
                    search: payload.search,
                    priorities: payload.priorities,
                    owner: payload.owner,
                    followers: payload.followers,
                    dateRange: payload.dateRange,
                    createdBy: payload.createdBy,
                    tags: payload.tags,
                    startDateRange: payload.startDateRange,
                    endDateRange: payload.endDateRange,
                    updateAtRange: payload.updateAtRange
                };

                const [tasksResult] = await Promise.all([
                    tasksPromise,
                    dispatch('getWorkflowPipelines', {
                        workflowId: payload.workflowId,
                        pipelines: payload.pipelines,
                        filters: filters
                    }).catch((error) => {
                    console.warn('Pipeline güncelleme hatası:', error);
                        return null;
                    })
                ]);

                return tasksResult;
            }

            return await tasksPromise;
        },
        getListArchiveTasks({}, payload) {
            return getListArchiveTasks(
                payload.siteId,
                payload.assignees,
                payload.page,
                payload.perPage,
                payload.visitorId,
                payload.search,
                payload.priorities,
                payload.owner,
                payload.followers,
                payload.dateRange,
                payload.createdBy,
                payload.tags,
                payload.startDateRange,
                payload.endDateRange,
                payload.updateAtRange,
                payload.showOverdue,
                payload.workflowId,
                payload.pipelines
            ).then((res) => res.data);
        },
        getListDoneTask({}, payload) {
            return getListDoneTask(
                payload.assignees,
                payload.page,
                payload.perPage,
                payload.visitorId,
                payload.search,
                payload.priorities,
                payload.owner,
                payload.followers,
                payload.dateRange,
                payload.createdBy,
                payload.tags,
                payload.startDateRange,
                payload.endDateRange,
                payload.updateAtRange,
                payload.showOverdue,
                payload.workflowId,
                payload.pipelines
            ).then((res) => res.data);
        },
        deletePipelineStage({ commit, state }, payload) {
            return deletePipelineStage(payload.pipelineId, payload.workflowId, payload.newTaskPositionId)
                .then((res) => res.data)
                .then((pipeline) => {
                    const workflows = state.workflows.map((wf) => {
                            if (wf._id === payload.workflowId) {
                            const updatedPipeline = wf.pipeline.filter(pl => pl._id !== payload.pipelineId);
                            return Object.assign({}, wf, { pipeline: updatedPipeline });
                            }
                            return wf;
                    });
                    commit("SET_WORKFLOWS", workflows);
                    return pipeline;
                });
        },
        getWorkflowDetails({}, params) {
            return getWorkflowDetails(params.workflowId).then((res) => res.data);
        },
        multipleTaskDelete({ commit, state }, { taskIds, tasks }) {
            return multipleTaskDelete(taskIds)
                .then((res) => {
                    if (tasks && tasks.length > 0) {
                        const taskHash = tasks.reduce((acc, task) => {
                            if (task.workflow && task.pipelineStage) {
                                const key = `${task.workflow}_${task.pipelineStage}`;
                                acc[key] = (acc[key] || 0) + 1;
                            }
                            return acc;
                        }, {});

                        const workflows = state.workflows.map((wf) => {
                            const pipeline = wf.pipeline.map((pl) => {
                                const key = `${wf._id}_${pl._id}`;
                                if (taskHash[key]) {
                                    const newCount = Math.max(0, (pl.taskCount || 0) - taskHash[key]);
                                    const newFilteredCount = pl.filteredTaskCount !== undefined
                                        ? Math.max(0, (pl.filteredTaskCount || 0) - taskHash[key])
                                        : newCount;
                                    return Object.assign({}, pl, {
                                        taskCount: newCount,
                                        filteredTaskCount: newFilteredCount
                                    });
                                }
                                return pl;
                            });
                            return Object.assign({}, wf, { pipeline });
                        });
                        commit("SET_WORKFLOWS", workflows);
                    }
                    return res.data;
                });
        },
        multipleTaskMove({ commit, state }, { payload, tasks }) {
            return multipleTaskMove(payload.pipelineId, payload.taskIds)
                .then((res) => {
                    if (tasks && tasks.length > 0 && payload.pipelineId) {
                        const fromPipelineHash = tasks.reduce((acc, task) => {
                            if (task.workflow && task.pipelineStage) {
                                const key = `${task.workflow}_${task.pipelineStage}`;
                                acc[key] = (acc[key] || 0) + 1;
                            }
                            return acc;
                        }, {});

                        const workflows = state.workflows.map((wf) => {
                            const pipeline = wf.pipeline.map((pl) => {
                                const key = `${wf._id}_${pl._id}`;
                                if (fromPipelineHash[key] && pl._id !== payload.pipelineId) {
                                    const newCount = Math.max(0, (pl.taskCount || 0) - fromPipelineHash[key]);
                                    const newFilteredCount = pl.filteredTaskCount !== undefined
                                        ? Math.max(0, (pl.filteredTaskCount || 0) - fromPipelineHash[key])
                                        : newCount;
                                    return Object.assign({}, pl, {
                                        taskCount: newCount,
                                        filteredTaskCount: newFilteredCount
                                    });
                                }
                                if (pl._id === payload.pipelineId) {
                                    const newCount = (pl.taskCount || 0) + tasks.length;
                                    const newFilteredCount = pl.filteredTaskCount !== undefined
                                        ? (pl.filteredTaskCount || 0) + tasks.length
                                        : newCount;
                                    return Object.assign({}, pl, {
                                        taskCount: newCount,
                                        filteredTaskCount: newFilteredCount
                                    });
                                }
                                return pl;
                            });
                            return Object.assign({}, wf, { pipeline });
                        });
                        commit("SET_WORKFLOWS", workflows);
                    }
                    return res.data;
                });
        },
        multipleTaskDone({ commit, state }, { taskIds, tasks }) {
            return multipleTaskDone(taskIds).then((res) => {
                if (tasks && tasks.length > 0) {
                    const taskHash = tasks.reduce((acc, task) => {
                        if (task.workflow && task.pipelineStage) {
                            const key = `${task.workflow}_${task.pipelineStage}`;
                            acc[key] = (acc[key] || 0) + 1;
                        }
                        return acc;
                    }, {});

                    const workflows = state.workflows.map((wf) => {
                        const pipeline = wf.pipeline.map((pl) => {
                            const key = `${wf._id}_${pl._id}`;
                            if (taskHash[key]) {
                                const newCount = Math.max(0, (pl.taskCount || 0) - taskHash[key]);
                                const newFilteredCount = pl.filteredTaskCount !== undefined
                                    ? Math.max(0, (pl.filteredTaskCount || 0) - taskHash[key])
                                    : newCount;
                                return Object.assign({}, pl, {
                                    taskCount: newCount,
                                    filteredTaskCount: newFilteredCount
                                });
                            }
                            return pl;
                        });
                        return Object.assign({}, wf, { pipeline });
                    });
                    commit("SET_WORKFLOWS", workflows);
                }
                return res.data;
            });
        },
        deleteWorkflow({ commit, state }, workflowId) {
            return deleteWorkflow(workflowId)
                .then((res) => res.data)
                .then((body) => {
                    commit("SET_WORKFLOWS", state.workflows.filter((wf) => wf._id !== workflowId));
                    return body;
                });
        },
        getTaskListByDate({}, { userId, startDate, endDate }) {
            return getTaskListByDate(userId, startDate, endDate).then((res) => res.data);
        },
        changeWorkflow({ commit, state }, { taskId, workflowId, oldWorkflowId, oldPipelineId }) {
            return changeWorkflow(taskId, workflowId).then((res) => {
                // Task taşındı, state'i güncelle
                if (oldWorkflowId && oldPipelineId) {
                    const workflows = state.workflows.map((wf) => {
                        // Eski workflow'dan count azalt
                        if (wf._id === oldWorkflowId) {
                            const pipeline = wf.pipeline.map((pl) => {
                                if (pl._id === oldPipelineId) {
                                    const newCount = Math.max(0, (pl.taskCount || 0) - 1);
                                    const newFilteredCount = pl.filteredTaskCount !== undefined
                                        ? Math.max(0, (pl.filteredTaskCount || 0) - 1)
                                        : newCount;
                                    return Object.assign({}, pl, {
                                        taskCount: newCount,
                                        filteredTaskCount: newFilteredCount
                                    });
                                }
                                return pl;
                            });
                            return Object.assign({}, wf, { pipeline });
                        }
                        // Yeni workflow'a todo stage count'u artır
                        if (wf._id === workflowId) {
                            const pipeline = wf.pipeline.map((pl) => {
                                if (pl.type === 'todo') {
                                    const newCount = (pl.taskCount || 0) + 1;
                                    const newFilteredCount = pl.filteredTaskCount !== undefined
                                        ? (pl.filteredTaskCount || 0) + 1
                                        : newCount;
                                    return Object.assign({}, pl, {
                                        taskCount: newCount,
                                        filteredTaskCount: newFilteredCount
                                    });
                                }
                                return pl;
                            });
                            return Object.assign({}, wf, { pipeline });
                        }
                        return wf;
                    });
                    commit("SET_WORKFLOWS", workflows);
                }
                return res.data;
            });
        },
        updateWorkflowOrder({ commit, dispatch }, workflows) {
            return updateWorkflowOrder(workflows).then((res) => {
                commit("SET_WORKFLOWS", res.data);
                return dispatch("getWorkFlows");
            });
        },
        getWorkflowPipelines({ commit, state }, { workflowId, pipelines, filters }) {
            return getWorkflowPipelines(workflowId, pipelines, filters)
                .then((res) => {
                    if (res.data && workflowId) {
                        const workflows = state.workflows.map((wf) => {
                    if (wf._id === workflowId) {
                                return Object.assign({}, wf, { pipeline: res.data });
                            }
                            return wf;
                        });
                        commit("SET_WORKFLOWS", workflows);
                    }
                    return res.data;
                });
        },
        getPiplineName({}, workflowId) {
            return getPiplineName(workflowId).then((res) => res.data);
        },
        incWorkflowPipelineTaskCount({ commit, state }, { workflowId, pipelineId, count = 1 }) {
            const workflows = state.workflows.map((wf) => {
                if (wf._id === workflowId) {
                    const pipeline = wf.pipeline.map((pl) => {
                        if (pl._id === pipelineId) {
                            return Object.assign({}, pl, {
                                taskCount: (pl.taskCount || 0) + count
                            });
                        }
                        return pl;
                    });
                    return Object.assign({}, wf, { pipeline });
                }
                return wf;
            });
            commit("SET_WORKFLOWS", workflows);
        },
        decWorkflowPipelineTaskCount({ commit, state }, { workflowId, pipelineId, count = 1 }) {
            const workflows = state.workflows.map((wf) => {
                if (wf._id === workflowId) {
                    const pipeline = wf.pipeline.map((pl) => {
                        if (pl._id === pipelineId) {
                            const newCount = Math.max(0, (pl.taskCount || 0) - count);
                            return Object.assign({}, pl, { taskCount: newCount });
                        }
                        return pl;
                    });
                    return Object.assign({}, wf, { pipeline });
                }
                return wf;
            });
            commit("SET_WORKFLOWS", workflows);
        },
        getTaskReports({}, { filters }) {
            return getTaskReports(filters).then((res) => res.data);
        },
        getTaskReportsTimeline({}, { userId, filters }) {
            return getTaskReportsTimeline(userId, filters).then((res) => res.data);
        },
    },
};
export default tasks;
